import { Action, createReducer, on } from '@ngrx/store';
import * as googleAPIKeyActions from '../actions/google-api-key.actions';

export const googleAPIKeyFeatureKey = 'googleAPIKey';

export interface GoogleAPIKeyState {
  loading: boolean;
  encryptedData: string | null;
  error: any;
}

export const initialState: GoogleAPIKeyState = {
  loading: false,
  encryptedData: null,
  error: null
};

export const reducer = createReducer(
  initialState,
  on(googleAPIKeyActions.loadGoogleAPIKey, state => ({ ...state, loading: true, error: null })),
  on(googleAPIKeyActions.loadGoogleAPIKeySuccess, (state, { encryptedData }) => ({ ...state, loading: false, encryptedData, error: null })),
  on(googleAPIKeyActions.loadGoogleAPIKeyFailure, (state, { error }) => ({ ...state, loading: false, error }))
);

export const getGoogleAPIKey = (state: GoogleAPIKeyState) => state.encryptedData;
export const getGoogleAPIKeyLoading = (state: GoogleAPIKeyState) => state.loading;
export const getGoogleAPIKeyError = (state: GoogleAPIKeyState) => state.error;

